import {
  Component,
  computed,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import {
  RouterLink,
  RouterOutlet,
  RouterLinkActive,
  Router,
} from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { AvatarModule } from 'primeng/avatar';
import { AuthService } from '../../services/auth.service';
import { AccessTokenService } from '../../services/access-token.service';
import { LoggedUserStateService } from '../../services/logged-user-state.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-customer-area',
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    DrawerModule,
    ButtonModule,
    AvatarModule,
    ProgressSpinnerModule,
  ],
  templateUrl: './customer-area.component.html',
  styleUrl: './customer-area.component.scss',
})
export class CustomerAreaComponent {
  private router = inject(Router);
  private authService = inject(AuthService);
  private accessTokenService = inject(AccessTokenService);
  private loggedUserStateService = inject(LoggedUserStateService);

  loading = signal(false);

  showSidebar = signal(true);

  isMobile = signal(false);

  protected customer = computed(() => this.loggedUserStateService.user());

  ngOnInit() {
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 767) {
        this.isMobile = signal(true);
        this.showSidebar.set(false);
      } else {
        this.isMobile = signal(false);
        this.showSidebar.set(true);
      }
    });
  }

  isRouterActive(route: string): boolean {
    return this.router.isActive(route, {
      paths: 'exact',
      queryParams: 'exact',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }

  toggleSidebar() {
    this.showSidebar.update((value) => !value);
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscKey(event: any) {
    if (this.showSidebar()) this.toggleSidebar();
  }

  @HostListener('click', ['$event'])
  onClickScreen(event: any) {
    if (this.showSidebar()) this.toggleSidebar();
  }

  logOut(): void {
    const token = this.accessTokenService.getAccessToken();
    if (token) {
      this.loading.set(true);

      this.authService
        .logOut({ token, tokenTypeHint: 'access_token' })
        .subscribe({
          next: () => {
            this.loggedUserStateService.clear();
            this.accessTokenService.clearSession();

            this.router.navigate(['/home'], { replaceUrl: true });
            this.loading.set(false);
          },
          error: (e) => {
            this.loading.set(false);
          },
        });
    }
  }
}
